import React from 'react';
import CryptoForm from './CryptoForm'; // Import CryptoForm component

function App() {
  return (
    <div className="App">
       <CryptoForm />
       
    </div>
  );
}

export default App;
